import { makeStyles } from '@material-ui/core/styles'

const styles = () => ({
  accordionDetails: {
    display: 'block',
    color: '#92929F',
  },
  question: {
    fontFamily: 'proximanova-bold',
  },
})

export default makeStyles(styles)
